<template>
  <div class="union-chapter">
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="summary-text" v-html="unionSketch"></div>
      </el-col>
      <el-col :span="8">
        <div>
          <img :src="summaryPic" width="100%" alt="">
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      unionSketch: '',
      summaryPic: '../../../../static/img/6969393-1.png'
    };
  },
  created() {
    this.initSummary(8);
  },
  methods: {
    initSummary(textNo) {
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: textNo }).then(
        res => {
          this.unionSketch = res.data.records[0].commonText;
        }
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.summary-text {
  text-indent: 2em;
  line-height: 28px;
}

.union-chapter {
  width: 100%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/overview/unionSummary.vue